import promise from 'bluebird'

import {hairdresserConstants, alertConstants, bookingConstants, userConstants} from '../_constants';

import {bookingService, hairdresserService, userService} from "../_services";

import { ResponseFilter } from "../config/response-handler";

export const hairdresserActions = {
    getSalonProfile,
    getHairdresserScheduleReset,
    getHairdresserClient,
    hairdresserSwitchProfile,
    getHairdresserClientDetail,
    createClient,
    addStaff,
    editStaff,
    getHairdresserService,
    hairdresserStaffRota,
    editClient,
    removeStaff,
    deleteClient,
    checkEmailAvailability,
    serviceHairdresserList,
    getLastBookedClients,
    updateHairdresserSchedule,
    dairyFilterData,
    dairyFilterStaffOrderList,
    hairdresserStaffWithoutService,
    staffRotaUpdateDelete,
    activeFilterStatus,
    selectedService,
    getHairdresserInfoWeb,
    getSalonServicesWeb,
    salonOwnerInfo,
    getHairdresserPolicies,
    saveWorkingRota,
    saveClientListState,
    clearClientListState,
    getDiaryData,
    saveDiaryStaffOrder,
    getStaffEditInfoV2,
};

// Action creators for client list state persistence
function saveClientListState(payload) {
    return { type: hairdresserConstants.HAIRDRESSER_CLIENT_LIST_STATE_SAVE, payload };
}

function clearClientListState() {
    return { type: hairdresserConstants.HAIRDRESSER_CLIENT_LIST_STATE_CLEAR };
}

/************************************** getStaffEditInfoV2 ******************************************************/

// Hits beu-node-v2 /hairdresser/:id/edit-info — replaces the legacy v1
// bookingProfile call used by the Edit Staff modal so we can phase out
// beu-backend dependency for that flow.
function getStaffEditInfoV2(params) {
    return function () {
        return hairdresserService.getStaffEditInfoV2(params);
    };
}

/************************************** getHairdresserInfo ******************************************************/


function getHairdresserInfoWeb(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.hairdresserProfileWeb(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    // Handle new v2 API response structure
                    const data = serverResponseData.responseData || serverResponseData.data;
                    dispatch(success(data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getHairdresserInfoRequest) { return { type: hairdresserConstants.HAIRDRESSER_INFO_REQUEST, getHairdresserInfoRequest } }
    function success(getHairdresserInfoSuccess) { return { type: hairdresserConstants.HAIRDRESSER_INFO_SUCCESS, getHairdresserInfoSuccess } }
    function failure(getHairdresserInfoFail) { return { type: hairdresserConstants.HAIRDRESSER_INFO_ERROR, getHairdresserInfoFail } }
}

function getSalonServicesWeb(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.salonServicesWeb(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    // Handle new v2 API response structure
                    const data = serverResponseData.responseData || serverResponseData.data;
                    dispatch(success(data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getSalonServicesRequest) { return { type: hairdresserConstants.HAIRDRESSER_INFO_REQUEST, getSalonServicesRequest } }
    function success(getSalonServicesSuccess) { return { type: hairdresserConstants.HAIRDRESSER_INFO_SUCCESS, getSalonServicesSuccess } }
    function failure(getSalonServicesFail) { return { type: hairdresserConstants.HAIRDRESSER_INFO_ERROR, getSalonServicesFail } }
}


function updateHairdresserSchedule(data) {
    return function (dispatch) {
            dispatch(success(data));
    };

    function success(getHairdresserScheduleSuccess) { return { type: hairdresserConstants.UPDATE_HAIRDRESSER_SCHEDULE, getHairdresserScheduleSuccess }}
}

function getHairdresserScheduleReset(params,hairdresser) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(success({}));
        })
    };

    function success(getHairdresserScheduleReset) { return { type: hairdresserConstants.HAIRDRESSER_INFO_CLEAR } }

}

function saveDiaryStaffOrder(staffOrder) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.saveDiaryStaffOrder(staffOrder)
                .then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    resolve(serverResponseData);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    };
}

function getDiaryData(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.getDiaryData(params)
                .then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    resolve(serverResponseData);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    };
}


function getSalonProfile(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {
            let apiParams = {};

            apiParams.salonId = params.salonId;

            //dispatch(request(params));
            hairdresserService.salonProfile(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    //console.log("salonProfile serverResponseData", serverResponseData);
                    // Fix: Handle new API response structure
                    const responseData = serverResponseData.responseData || serverResponseData.data;
                    dispatch(success(responseData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getgetSalonProfileRequest) { return { type: hairdresserConstants.SALON_PROFILE_REQUEST, getgetSalonProfileRequest } }
    function success(getSalonProfileSuccess) { return { type: hairdresserConstants.SALON_PROFILE_SUCCESS, getSalonProfileSuccess } }
    function failure(getgetSalonProfileFail) { return { type: hairdresserConstants.SALON_PROFILE_ERROR, getgetSalonProfileFail } }
}


function getHairdresserClient(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            //dispatch(request(params));
            let requestParam={
                searchKey: params.searchKey,
                page: params.page || 1,
                limit: params.limit || 20, // Reduced from 50 to 20 for better performance with large client lists
                isDownload: params.isDownload,
                empIds:params?.empIds!=undefined?params?.empIds:'',
                startDate:params?.startDate!=undefined?params?.startDate:'',
                endDate:params?.endDate!=undefined?params?.endDate:'',
                minSales:params?.minSales,
                maxSales:params?.maxSales,
                sortField:params?.sortField || 'name',
                sortOrder:params?.sortOrder || 'asc'
            }
            
            // Use new paginated API
            hairdresserService.getClientsPaginated(requestParam)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    console.log('getHairdresserClient (paginated)',response);
                    
                    // Handle new v2 API response structure
                    const responseData = serverResponseData.responseData || serverResponseData.data;
                    
                    if(params?.isDownload===1 || params?.isDownload==='1'){
                        dispatch(exportCsv(responseData));
                    }else{
                        // Transform response to match old format for compatibility
                        const transformedData = {
                            client: responseData.clients || [],
                            pagination: responseData.pagination
                        };
                        dispatch(success(transformedData));
                    }
                  
                })
                .catch((err) => {
                    params.history.push('/');
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function exportCsv(getHairdresserClientSuccess) {return{type: hairdresserConstants.HAIRDRESSER_CLIENT_CSV_DOWNLOAD, getHairdresserClientSuccess}}
    function request(getHairdresserClientRequest) { return { type: hairdresserConstants.HAIRDRESSER_CLIENT_REQUEST, getHairdresserClientRequest } }
    function success(getHairdresserClientSuccess) { return { type: hairdresserConstants.HAIRDRESSER_CLIENT_SUCCESS, getHairdresserClientSuccess } }
    function failure(getHairdresserClientFail) { return { type: hairdresserConstants.HAIRDRESSER_CLIENT_ERROR, getHairdresserClientFail } }
}

function hairdresserSwitchProfile(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.switchProfile(params)
                .then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    // Update localStorage with new user data after profile switch
                    if (serverResponseData.data && serverResponseData.data.user) {
                        localStorage.setItem('user', JSON.stringify(serverResponseData.data.user));
                        if (serverResponseData.data.user._id) {
                            localStorage.setItem('userId', serverResponseData.data.user._id);
                        }
                        if (serverResponseData.data.user.hairdresser && serverResponseData.data.user.hairdresser.salon) {
                            localStorage.setItem('salonId', serverResponseData.data.user.hairdresser.salon._id || serverResponseData.data.user.hairdresser.salon);
                        }
                    }
                    // Only a successful switch replaces the signed-in user in the store.
                    if (serverResponseData && serverResponseData.errorCode === 0) dispatch(userSuccess(serverResponseData.data));
                    resolve(response);
                    dispatch(success(serverResponseData.data.reviews));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function userSuccess(profileSuccess) { return { type: userConstants.PROFILE_SUCCESS, profileSuccess } }
    function request(getHairdresserReviewRequest) { return { type: hairdresserConstants.HAIRDRESSER_SWITCH_REQUEST, getHairdresserReviewRequest } }
    function success(getHairdresserReviewSuccess) { return { type: hairdresserConstants.HAIRDRESSER_SWITCH_SUCCESS, getHairdresserReviewSuccess } }
    function failure(getHairdresserReviewFail) { return { type: hairdresserConstants.HAIRDRESSER_SWITCH_ERROR, getHairdresserReviewFail } }
}


function getHairdresserClientDetail(params) {
    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.getClientDetail(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    console.log("=== DISPATCHING TO REDUX ===");
                    console.log("Raw response:", response.data);
                    console.log("After ResponseFilter:", serverResponseData);
                    // Handle new v2 API response structure
                    const data = serverResponseData.responseData || serverResponseData.data;
                    console.log("Dispatching data:", data);
                    console.log("============================");
                    dispatch(success(data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getHairdresserClientDetailRequest) { return { type: hairdresserConstants.HAIRDRESSER_CLIENTDETAIL_REQUEST, getHairdresserClientDetailRequest } }
    function success(getHairdresserClientDetailSuccess) { return { type: hairdresserConstants.HAIRDRESSER_CLIENTDETAIL_SUCCESS, getHairdresserClientDetailSuccess } }
    function failure(getHairdresserClientDetailFail) { return { type: hairdresserConstants.HAIRDRESSER_CLIENTDETAIL_ERROR, getHairdresserClientDetailFail } }
}

function createClient(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {


            //dispatch(request(params));
            hairdresserService.clientAdd(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    //console.log("serverResponseData", serverResponseData);
                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    function request(createClientRequest) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_REQUEST, createClientRequest } }
    function success(createClientSuccess) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_SUCCESS, createClientSuccess } }
    function failure(createClientFail) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_ERROR, createClientFail } }
}


function addStaff(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            hairdresserService.addStaff(params)
                .then(response => {
                    resolve(response);

                    let { serverResponseData } = ResponseFilter(response);

                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    // function request(getHairdresserStaffRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_REQUEST, getHairdresserStaffRequest } }
    // function success(getHairdresserStaffSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_SUCCESS, getHairdresserStaffSuccess } }
    // function failure(getHairdresserStaffFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ERROR, getHairdresserStaffFail } }
}

function editStaff(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            hairdresserService.editStaff(params)
                .then(response => {
                    resolve(response);

                    let { serverResponseData } = ResponseFilter(response);

                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    // function request(getHairdresserStaffRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_REQUEST, getHairdresserStaffRequest } }
    // function success(getHairdresserStaffSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_SUCCESS, getHairdresserStaffSuccess } }
    // function failure(getHairdresserStaffFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ERROR, getHairdresserStaffFail } }
}


function getHairdresserService(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.hairdresserUserService(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    //console.log("serverResponseData", serverResponseData);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getHairdresserServiceRequest) { return { type: hairdresserConstants.HAIRDRESSER_SERVICE_REQUEST, getHairdresserServiceRequest } }
    function success(getHairdresserServiceSuccess) { return { type: hairdresserConstants.HAIRDRESSER_SERVICE_SUCCESS, getHairdresserServiceSuccess } }
    function failure(getHairdresserServiceFail) { return { type: hairdresserConstants.HAIRDRESSER_SERVICE_ERROR, getHairdresserServiceFail } }
}


function hairdresserStaffWithoutService(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            hairdresserService.staffListServiceV2WithoutService(params)
                .then(response => {
                    resolve(response);

                    let { serverResponseData } = ResponseFilter(response);

                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(getHairdresserStaffServiceRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFFSERVICE_REQUEST, getHairdresserStaffServiceRequest } }
    function success(getHairdresserStaffServiceSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFFSERVICE_SUCCESS, getHairdresserStaffServiceSuccess } }
    function failure(getHairdresserStaffServiceFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFFSERVICE_ERROR, getHairdresserStaffServiceFail } }
}


function hairdresserStaffRota(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            //hairdresserService.staffRota(params)
            hairdresserService.staffRotaV2(params)
                .then(response => {
                    // resolve(response);
                    let { serverResponseData } = ResponseFilter(response);

                    // The API answers HTTP 200 even when it failed, so the real
                    // outcome lives in statusCode. Route those down the failure
                    // path or the UI cannot tell an error from "still loading".
                    if (serverResponseData?.statusCode !== 1) {
                        const apiError = new Error(serverResponseData?.error?.responseMessage || 'Unable to load staff');
                        resolve({status:200,data:{data:{rota:undefined}}});
                        dispatch(failure(apiError));
                        return;
                    }

                    // A staff row whose linked user record has been removed comes
                    // back as null. Strip those here so no consumer has to guard.
                    const result = serverResponseData?.responseData?.result;
                    const rota = Array.isArray(result) ? result.filter(Boolean) : result;

                    resolve({status:200,data:{data:{rota:rota}}});

                    // dispatch(success(serverResponseData.data));
                    dispatch(success({rota:rota}));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(hairdresserStaffRotaRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_REQUEST, hairdresserStaffRotaRequest } }
    function success(hairdresserStaffRotaSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_SUCCESS, hairdresserStaffRotaSuccess } }
    function failure(hairdresserStaffRotaFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_ERROR, hairdresserStaffRotaFail } }
}

function staffRotaUpdateDelete(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(success(params));

        })
    };
    function request(hairdresserStaffRotaRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_REQUEST, hairdresserStaffRotaRequest } }
    function success(hairdresserStaffRotaSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_SUCCESS, hairdresserStaffRotaSuccess } }
    function failure(hairdresserStaffRotaFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ROTA_ERROR, hairdresserStaffRotaFail } }
}

function editClient(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {


            //dispatch(request(params));
            hairdresserService.editClient(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    //console.log("serverResponseData", serverResponseData);
                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    function request(createClientRequest) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_REQUEST, createClientRequest } }
    function success(createClientSuccess) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_SUCCESS, createClientSuccess } }
    function failure(createClientFail) { return { type: bookingConstants.HAIRDRESSER_CLIENTCREATE_ERROR, createClientFail } }
}

function removeStaff(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            hairdresserService.removeStaff(params)
                .then(response => {
                    resolve(response);

                    let { serverResponseData } = ResponseFilter(response);

                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    // function request(getHairdresserStaffRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_REQUEST, getHairdresserStaffRequest } }
    // function success(getHairdresserStaffSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_SUCCESS, getHairdresserStaffSuccess } }
    // function failure(getHairdresserStaffFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ERROR, getHairdresserStaffFail } }
}

function deleteClient(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            hairdresserService.deleteClient(params)
                .then(response => {
                    resolve(response);

                    //let { serverResponseData } = ResponseFilter(response);

                    //dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    // function request(getHairdresserStaffRequest) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_REQUEST, getHairdresserStaffRequest } }
    // function success(getHairdresserStaffSuccess) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_SUCCESS, getHairdresserStaffSuccess } }
    // function failure(getHairdresserStaffFail) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_ERROR, getHairdresserStaffFail } }
}

function checkEmailAvailability(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.checkEmailAvailability(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function serviceHairdresserList(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.serviceHairdresserList(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function getLastBookedClients (params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.getLastBookedClients(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function getHairdresserPolicies(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.getHairdresserPolicies(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function dairyFilterData(data) {
    return function (dispatch) {
          dispatch(success(data));
        }
    function success(hairdresserStaff) { return { type: hairdresserConstants.HAIRDRESSER_STAFF_FILTER_DATA, hairdresserStaff } }
}

function activeFilterStatus(data) {
    return function (dispatch) {
          dispatch(success(data));
        }
    function success(activeStatus) { return { type: hairdresserConstants.ACTIVE_FILTER_STATUS, activeStatus } }
}

function dairyFilterStaffOrderList(data) {
    return function (dispatch) {
          dispatch(success(data));
        }
    function success(hairdresserStaff) { return { type: hairdresserConstants.STAFF_FILTER_ORDERED_LIST, hairdresserStaff } }
}


function selectedService(data){
    return function (dispatch) {
        dispatch({ type: hairdresserConstants.SELECTED_SERVICE, data })
    };
  };


function salonOwnerInfo(data){
    return function (dispatch) {
        dispatch({ type: hairdresserConstants.SALON_OWNER_INFO, data })
    };
  };

function saveWorkingRota(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            hairdresserService.saveWorkingRota(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}
